export default __webpack_public_path__ + "static/media/iceCream.e3bf98bb.jpg";